import JsonUrl from 'json-url';

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var lib = JsonUrl("lzma");

var compress = function compress(_ref) {
  var object = _ref.object,
      schema = _ref.schema,
      onSuccess = _ref.onSuccess;

  var transform = function transform(source, _schema) {
    // In case the schema is undefined execute this part
    if (!_schema || _typeof(_schema) !== "object") {
      // Different type of leafs:
      // 1. Array, return the array in an array due to spreading in the function call of transform
      // 2. objects, we are only interested in the values, keys are discarded. Every value counts as one leaf
      // 3. rest, return it as wrapped array.
      if (Array.isArray(source)) {
        return [source];
      } else if (_typeof(source) === "object") {
        return Object.values(source);
      } else return [source];
    } // collect the result, which is an array of all leafs in this part of the tree


    var result = [];
    Object.entries(source).sort(function (a, b) {
      return b[0].localeCompare(a[0]);
    }).forEach(function (_ref2) {
      var _schema$key;

      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0];
          _ref3[1];

      if (((_schema$key = _schema[key]) === null || _schema$key === void 0 ? void 0 : _schema$key.type) === "ignore") {
        result = [].concat(_toConsumableArray(result), [JSON.stringify(source[key])]);
      } else if (_schema[key] && _typeof(_schema[key]) === "object" && _schema[key].hasOwnProperty("dict")) {
        var _schema$key2 = _schema[key],
            type = _schema$key2.type,
            dict = _schema$key2.dict;
        result = [].concat(_toConsumableArray(result), [// only apply transformation function if it exists, else keep source value
        type === "array" ? Object.values(source[key]).map(function (val) {
          return dict.indexOf(val);
        }) : dict.indexOf(source[key])]);
      } else {
        // in case there is no transformation function, dig deeper
        result = [].concat(_toConsumableArray(result), _toConsumableArray(transform(source[key], _schema[key])));
      }
    });
    return result;
  };

  var transformed = transform(object, schema);
  lib.compress(transformed).then(function (result) {
    return onSuccess(result);
  });
};

var decompress = function decompress(_ref4) {
  var string = _ref4.string,
      schema = _ref4.schema,
      onSuccess = _ref4.onSuccess;
  lib.decompress(string).then(function (valueList) {
    var i = 0;

    var transform = function transform(skeleton, values) {
      if (skeleton) {
        if (skeleton.type === "ignore") {
          return JSON.parse(values[i++]);
        }

        if (skeleton.hasOwnProperty("dict")) {
          // reached a leaf, determine possible dict reversal
          if (skeleton.type === "array") {
            return values[i++].map(function (val) {
              return skeleton.dict[val];
            });
          } else if (skeleton.type === "value") {
            return skeleton.dict[values[i++]];
          }

          return skeleton;
        }
      } // assemble object for this subtree


      var result = {};
      Object.entries(skeleton).sort(function (a, b) {
        return b[0].localeCompare(a[0]);
      }).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0];
            _ref6[1];

        if (!skeleton[key]) {
          result[key] = values[i++];
        } else {
          result[key] = transform(skeleton[key], values);
        }
      });
      return result;
    };

    var originalObj = transform(schema, valueList);
    return onSuccess(originalObj);
  });
};

export { compress, decompress };
